var map = {
	"./big-triangle.svg": 90074,
	"./cross.svg": 44364,
	"./diamond.svg": 6578,
	"./dot.svg": 81042,
	"./line.svg": 79200,
	"./oval.svg": 36393,
	"./polygon.svg": 40089,
	"./rectangle.svg": 59538,
	"./triangle.svg": 38323
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57217;